import { useEffect, useState } from 'react'

const getOrientationBySize = () =>
    window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'

export const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(getOrientationBySize())

    useEffect(() => {
        const handler = () => {
            setOrientation(getOrientationBySize())
        }

        window.addEventListener('resize', handler)

        return () => {
            window.removeEventListener('resize', handler)
        }
    }, [])

    return { orientation }
}
